export const toggleLoading = 'toggleLoading';
export const setPaymentDetails = 'setPaymentDetails';
export const setErrorMessages = 'setErrorMessages';
export const setPaypalDetails = 'setPaypalDetails';